import { render, staticRenderFns } from "./capacity-fixed.vue?vue&type=template&id=18fb275a&scoped=true&"
import script from "./capacity-fixed.vue?vue&type=script&lang=js&"
export * from "./capacity-fixed.vue?vue&type=script&lang=js&"
import style0 from "./capacity-fixed.vue?vue&type=style&index=0&id=18fb275a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fb275a",
  null
  
)

export default component.exports